import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RebootGateway } from 'core/domain/gateways/repositories/rebootGateway';
import { useEnvironment } from './useEnvironment';
import { useUserSession } from './useUserSession';
import { MessageErrorModel, useMessage } from './useMessage';

export const useRebootGateway = () => {
  const { t } = useTranslation();
  const { host } = useEnvironment();
  const { token } = useUserSession();
  const { setMessageError, setMessageSuccess } = useMessage();
  const [gatewayId, setGetwayId] = useState<string>('');
  const [isRebootable, setIsRebootable] = useState<boolean>(false);
  const [isRebootGatewayLoading, setIsRebootGatewayLoading] = useState<boolean>(false);
  const [isRebootGatewayModalVisible, setIsRebootGatewayModalVisible] = useState<boolean>(false);

  const rebootGatewayLiterals = {
    rebootGatewayModalTitle: t('_REBOOT_GATEWAY_MODAL_TITLE'),
    rebootGatewayModalText: isRebootable ? t('_REBOOT_GATEWAY_MODAL_TEXT_REBOOTABLE') : t('_REBOOT_GATEWAY_MODAL_TEXT_NOT_REBOOTABLE'),
    rebootGatewayModalMainButtonText: t('_REBOOT_GATEWAY_MODAL_MAIN_BUTTON'),
    rebootGatewayModalSecondaryButtonText: t('cancel'),
  };

  const onConfirmRebootGateway = async () => {
    setIsRebootGatewayLoading(true);
    try {
      await RebootGateway({ host, token, gatewayId });
      setMessageSuccess({ description: t('_REBOOT_GATEWAY_SUCCESS_MESSAGE') });
    } catch (error) {
      const isGatewayOfflineError = (error as MessageErrorModel).code === 504;
      const description = isGatewayOfflineError ? t('_REBOOT_GATEWAY_ERROR_GATEWAY_OFFLINE_MESSAGE') : t('_REBOOT_GATEWAY_ERROR_MESSAGE');
      setMessageError({ description });
    } finally {
      setIsRebootGatewayLoading(false);
      setIsRebootGatewayModalVisible(false);
    }
  };

  const onRebootGateway = (isRebootable: boolean, gatewayId: string) => {
    setIsRebootable(isRebootable);
    isRebootable && setGetwayId(gatewayId);
    setIsRebootGatewayModalVisible(true);
  };

  const onCancelRebootGateway = () => {
    setIsRebootGatewayModalVisible(false);
  };

  return {
    rebootGatewayLiterals,
    onRebootGateway,
    onCancelRebootGateway,
    onConfirmRebootGateway,
    isRebootGatewayLoading,
    isRebootGatewayModalVisible,
    isConfirmRebootGatewayButtonDisabled: !isRebootable,
  };
};
